<template>
  <div class="col-6 col-md-3 mb-5">
    <router-link
      :to="{ name: ROUTE_INDEX }"
      class="img animateMe"
      data-animation="fadeInDown"
    >
      <img
        v-if="isThaiCharoenPlus"
        src="@/assets/v3/logo-sd-tp.png"
        alt=""
      />
      <img
        v-else-if="isSevenColor"
        src="@/assets/v3/logo-sd-mc.png"
        alt=""
      />
      <img
        v-else-if="isThaisiam"
        src="@/assets/v3/logo-sd-ts.png"
        alt=""
      />
      <img
        v-else-if="isHuaypromt"
        src="@/assets/v3/logo-sd-hp.png"
        alt=""
      />
      <img
        v-else-if="isJertjarat"
        src="@/assets/v3/logo-sd-jj.png"
        alt=""
      />
      <img
        v-else-if="isLottoslot88"
        src="@/assets/v3/logo-sd-ls.png"
        alt=""
      />
      <img
        v-else-if="isChokCharoen"
        src="@/assets/v3/logo-sd-cc.png"
        alt=""
      />
      <img
        v-else
        src="@/assets/v3/logo-sd.png"
        alt=""
      />
    </router-link>
  </div>
</template>

<script> 
import { ROUTE_INDEX } from '@/const/route'
export default {
  data () {
    return {
      ROUTE_INDEX,
    }
  },
}
</script>